import { AfterViewInit, Component, Injector, OnDestroy } from '@angular/core';
import { DocumentEditItemBase } from '../edit-item-base';
import { DocumentPanelRootService } from '../../document-panel-root/document-panel-root.service';
import { DocumentEditItemAdvancedTextPanelComponent } from '../advanced-text-panel/advanced-text-panel.component';

@Component({
    selector: 'fi-document-edit-item-advanced-text',
    template: '',
    styleUrls: ['./advanced-text.component.scss'],
    standalone: false,
})
export class DocumentEditItemAdvancedTextComponent extends DocumentEditItemBase implements AfterViewInit, OnDestroy {
    constructor(
        injector: Injector,
        public documentPanelRootService: DocumentPanelRootService,
    ) {
        super(injector);
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.documentPanelRootService.setPanel(DocumentEditItemAdvancedTextPanelComponent, this.injector, this);
        });
    }

    ngOnDestroy() {
        setTimeout(() => {
            if (this.documentPanelRootService.editComponent === this)
                this.documentPanelRootService.setPanel(null, null, null);
        });
    }
}
